import { Card, Col, Row } from "antd";
import type { Project } from "../../../types/projects";
import spacing from "../../../components/ui/spacingConfig";
import StatusBadges from "../../../components/tables/StatusBadges";
import AttachmentPreview from "../../../components/ui/AttachmentPreview";

type Props = {
  projectData: Project | undefined;
  className?: string;
};

const CardDescriptionProject: React.FC<Props> = ({ projectData, className }) => {
  return (
    <Card title="Description" bordered={false} className={className}>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Statut</p>
        </Col>
        <Col span={spacing.s}>
          <p>
            {projectData?.statut ? (
              <StatusBadges value={projectData?.statut} type="projects" />
            ) : (
              "Not found"
            )}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Titre</p>
        </Col>
        <Col span={spacing.s}>
          <p>{projectData?.name}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Description</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">{projectData?.description}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Mesure ImmÃ©diate</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">{projectData?.firstMeasure}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Auteur</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-light-blue">{projectData?.creator?.fullname}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">PiÃ¨ces jointes</p>
        </Col>
        <Col span={spacing.s}>
          <div className="attachments-container">
            {projectData?.attachedFiles.map((file) => (
              <AttachmentPreview key={file.id} fileUrl={file.file} />
            ))}
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">AccÃ¨s - Utilisateurs</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">
            {projectData?.accessGivenTo?.length
              ? projectData.accessGivenTo.map((user) => user.fullname).join(", ")
              : "-"}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">AccÃ¨s - RÃ´les</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">
            {projectData?.accessRoleGivenTo?.length
              ? projectData.accessRoleGivenTo
                  .map((role) => role.displayName)
                  .join(", ")
              : "-"}
          </p>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDescriptionProject;
